import lru from 'tiny-lru';
export const globalLruCache = lru();
//# sourceMappingURL=global-lru-cache.js.map